import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogActions, DialogContent,
  TextField, Button, Typography
} from "@material-ui/core";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import axios from "../../../config/axios";
import { getOrder } from "redux/action/order.action";

export default function ExtendSubscriptionDialog({ open, onClose, orderId }) {
  const [months, setMonths] = useState("1");
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const m = parseInt(months, 10);
    if (!m || m < 1) {
      enqueueSnackbar("Indique um número de meses válido.", { variant: "warning" });
      return;
    }
    setLoading(true);
    try {
      await axios.patch(`/admin/extend-subscription/${orderId}`, { months: m });
      enqueueSnackbar(`Subscrição estendida em ${m} mês(es).`, { variant: "success" });
      dispatch(getOrder({ id: orderId, type: "purchase-order" }));
      onClose();
    } catch (err) {
      enqueueSnackbar(err?.response?.data?.message || "Erro ao estender subscrição.", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Estender Subscrição</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
          Adiciona meses ao fim do período atual da subscrição.
        </Typography>
        <TextField
          fullWidth type="number" label="Número de meses"
          value={months} onChange={e => setMonths(e.target.value)}
          inputProps={{ min: 1 }} variant="outlined" size="small"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" disabled={loading}>
          {loading ? "A guardar..." : "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
